import _ from 'lodash';
import { IFeatureValue, IPick, IPlayer, IFeatureValueSet } from '@/store/modules/game/interfaces';
import { GetOUFantasyAspect, GetPlayerPosition } from '@/utils/GameUtils';

export default {
  getStatsModel: (sport: string, position: string, isGame: boolean): any => {
    if (sport === 'nba') {
      return ['points', 'rebounds', 'assists', 'block shots', 'steals', 'turn over'];
    }

    if (sport === 'mlb') {
      if (position === 'sp') {
        if (isGame) {
          return ['innings pitched (complete & partial)', 'earn runs allowed', 'hits allowed', 'total strikeouts', 'walks', 'wins'];
        } else {
          return ['innings pitched (complete & partial)', 'earn run average', 'total strikeouts', 'walks', 'wins'];
        }
      } else {
        if (isGame) {
          return ['hits', 'at bats', 'doubles', 'triples', 'home run', 'runs batted in', 'total runs scored', 'walk', 'stolen base', 'caught stealing', 'hit by pitch'];
        } else {
          return ['batting average', 'home run', 'runs batted in', 'total runs scored', 'stolen base'];
        }

      }
    }

    if (sport === 'ufc') {
      return ['significant strike', 'takedown', 'submission attempt', 'knockdown', '1st round win', '2nd round win', '3rd round win', '4th round win', '5th round win', 'win by decision']
    }

    if (sport === 'soccer') {
      if (position === 'gk' || position === 'goalkeeper') {
        return ['saves', 'saves from penalty', 'goals conceded', 'clean sheets', 'goals'];
      }

      return ['goals', 'goal assist', 'shots on target', 'total shots', 'key passes'];
    }

    if (sport === 'nfl') {
      return ['passing yards', 'passing touchdown', 'interception', 'rushing yards', 'rushing touchdown', 'receptions', 'receiving yards', 'receiving touchdown', 'fumble lost', '2 point conversion'];
    }

    if (sport === 'ckt_t20' || sport === 'ckt_odi' || sport === 'ckt_test') {
      var ba = ['run', '4-run bonus', '6-run bonus', 'half century', 'century', 'duck'];
      var bo = ['wicket (excl. run-out)', '4 wickets', '5 wickets', 'maiden', 'caught and bowled'];

      if (position === 'ba') {
        return ba;
      }

      if (position === 'bo') {
        return bo;
      }

      if (position === 'ar') {
        return _.union(ba, bo);
      }
    }

    if (sport === 'nhl') {
      var s = ['goals', 'assists', 'shots on goal', 'short handed g/a bonus', 'blocked shot'];
      var g = ['win', 'save', 'goal against', 'shutout'];

      if (position === 'g') {
        return _.union(s, g);
      }

      if (position === 'f') {
        return s;
      }

      if (position === 'd') {
        return s;
      }

      if (position === 's') {
        return s;
      }
    }
  },
  aliasStatName: (stat: IFeatureValue | null) => {
    if (!stat) { return null }

    if (_.isEmpty(stat)) {
      stat.name = '';
      return stat;
    }

    switch (stat.name.toLowerCase()) {
      case 'innings pitched (complete & partial)':
        stat.name = 'Innings Pitched';
        return stat;
      default: return stat;
    }
  },
  getRenderStat: function (stat: IFeatureValue) {
    if (stat.presentAs && !(stat.presentAs === '0')) { return stat.presentAs; }
    return stat.value;
  },
  generateStatsForMatchup: function (pickA: IPick, pickB: IPick, isGame: boolean) {
    const isOU = GetOUFantasyAspect(pickB);

    let set = 'seasonFeatureValueSet';
    if (isGame) {
      set = 'eventFeatureValueSet';
    }

    const setA = _.get(pickA.player, set);
    const setB = _.get(pickB.player, set);


    const aIsOu = !_.isEmpty(setA) && _.findIndex(setA.featureValues, (loc: IFeatureValue) => {
      return loc.shortName.toLowerCase() === 'ou'
    }) > 0

    let statsLocA: IFeatureValue[]
    let statsLocB: IFeatureValue[]
    if (_.isEmpty(setB) && _.isEmpty(setA)){
      statsLocA = [];
      statsLocB = [];
    }else {
      // one of the sets, but only one can now be empty
        if (aIsOu) {
          if (_.isEmpty(setA)) {
            statsLocB = []
            statsLocA = setB.featureValues || []
          }else {
            statsLocB = setA.featureValues || []
            statsLocA = setB.featureValues || []
          }
        } else {
          if (_.isEmpty(setA)) {
            statsLocA = []
          }else {
            statsLocA = setA.featureValues || [];
          }
          if (_.isEmpty(setB)) {
            statsLocB = []
          }else {
            statsLocB = setB.featureValues || [];
          }
        }
    }


    const statsModel = this.getStatsModel(pickA.player.aspect.name.toLowerCase(), GetPlayerPosition(pickA.player).toLowerCase(), isGame);
    //makes 'this' scoping in the matcher more clean
    
    const aliasGenerator = this.aliasStatName

    const matcher = _.map(statsLocA, function (s: IFeatureValue) {
      const key = s.name.toLowerCase();
      const matched: (IFeatureValue | null) = _.find(statsLocB, function (t) { return t.name.toLowerCase() === key; }) || null;
      const eitherHadMeaningfulValue = s.value || _.get(matched, 'value');
      
      //if (matched) {
        if (eitherHadMeaningfulValue || isGame) {
          let ret = {
            a: aliasGenerator(s),
            b: aliasGenerator(matched)
          };

          return ret
        }
      //}
    });

    var cleanMatcher = _.sortBy(_.compact(matcher), function (x: IPlayer) {
      if (x.name) { return _.indexOf(statsModel, x.name.toLowerCase()); }
    });

    if (!cleanMatcher || cleanMatcher.length === 0) { return; }
    return {
      a: _.map(cleanMatcher, 'a'),
      b: _.map(cleanMatcher, 'b')
    };
  }
}
